module.exports = __webpack_public_path__ + "img/DieSteineGehorchenMir.9b3e278b.svg";